import React, { useState } from 'react';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import homelogo from '../../assets/ihub-logo-header.svg';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './navbar.css';

const Topbar = () => {
  const location = useLocation();
  const isDropdownActive = location.pathname.startsWith('/hub-');
  const isProposalsActive = location.pathname.startsWith('/events') || location.pathname.startsWith('/proposals');

  const [isNavExpanded, setIsNavExpanded] = useState(false);

  const handleNavToggle = () => {
    setIsNavExpanded(!isNavExpanded);
  };
  
  return (
    <Navbar expand="lg" className="top-bar-bg" sticky="top" onToggle={handleNavToggle} expanded={isNavExpanded}>
      <div className="container-fluid px-4">
        <Navbar.Brand as={Link} to="/"><img src={homelogo} alt="home-logo" className='img-fluid w-75 py-2 top-logo'/></Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ml-auto nav-spc">
            {/* <Link className='nav-link' to="/">Home</Link> */}
            <NavLink
              to="/"
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
              onClick={() => setIsNavExpanded(false)}
            >
              Home
            </NavLink>
            {/* Organisation dropdown */}
            <NavDropdown title="About Us" id="basic-nav-dropdown1" active={isDropdownActive} onSelect={() => setIsNavExpanded(false)}>
            <NavDropdown.Item as={Link} to="/hub-about-us" className={`dropdown-item ${location.pathname === '/hub-about-us' ? 'active-link' : ''}`}>About IHub</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/hub-gov-board-team" className={`dropdown-item ${location.pathname === '/hub-gov-board-team' ? 'active-link' : ''}`}>Hub Governing Board</NavDropdown.Item>
                <NavDropdown.Item as={Link} to="/hub-team" className={`dropdown-item ${location.pathname === '/hub-team' ? 'active-link' : ''}`}>Team</NavDropdown.Item>
                
                {/* <NavDropdown.Item as={Link} to="/" className={`dropdown-item ${location.pathname === '/hub-focus-area' ? 'active-link' : ''}`}>IIIT-Hyd & NM-ICPS</NavDropdown.Item> */}
              </NavDropdown>
              {/* <NavLink as={Link} to="/events" activeclassname='active-link' onClick={() => setIsNavExpanded(false)}>Events</NavLink> */}
              {/* dropdown ends */}
              {/* Organisation dropdown */}
              <NavDropdown title="Focus Areas" id="basic-nav-dropdown3" onSelect={() => setIsNavExpanded(false)}>
                 <NavDropdown.Item target='__blank' href='https://india-data.org/' >India Data</NavDropdown.Item>
                <NavDropdown.Item target='__blank' href='https://mobility.iiit.ac.in/' >Mobility</NavDropdown.Item>
                 <NavDropdown.Item target='__blank' href='https://hai.iiit.ac.in/'>Healthcare</NavDropdown.Item>
                 <NavDropdown.Item target='__blank' href='https://ihub-data.ai/'>Programs</NavDropdown.Item>
                 <NavDropdown.Item target='__blank' href='https://vikas.india-data.org/'>Translation</NavDropdown.Item>
                 {/* <NavDropdown.Item as={Link} to="/startups" onClick={() => setIsNavExpanded(false)} >Startups</NavDropdown.Item> */}
              </NavDropdown>
              {/* dropdown ends */}
            
            <NavLink
              to="/startups"
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
              onClick={() => setIsNavExpanded(false)}
            >Startups</NavLink>
            <NavLink
              to="/events"
              className={() => `nav-link${isProposalsActive ? ' active' : ''}`}
              onClick={() => setIsNavExpanded(false)}
            >Proposals & Events</NavLink>
            <NavLink
              to="/newsletters"
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
              onClick={() => setIsNavExpanded(false)}
            >Newsletters</NavLink>
            <NavLink
              to="/blogs"
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
              onClick={() => setIsNavExpanded(false)}
            >Blogs</NavLink>
            <NavLink
              to="/tenders"
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
              onClick={() => setIsNavExpanded(false)}
            >Tenders</NavLink>
            <NavLink
              to="/careers"
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
              onClick={() => setIsNavExpanded(false)}
            >Careers</NavLink>
            <NavLink
              to="/contact-us"
              className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
              onClick={() => setIsNavExpanded(false)}
            >Contact Us</NavLink>
          </Nav>
        </Navbar.Collapse>
      </div>
    </Navbar>
  );
}

export default Topbar;